import { create } from 'zustand';

import { stopMediaStream } from '@/shared/lib/media-devices';

export type MicInfo = {
    deviceId: string;
    name: string;
};

type MicState = {
    accessDenied: boolean | undefined;
    mics: MicInfo[] | undefined;
    currentMicId: string | undefined;
    currentStream: MediaStream | undefined;
    selectMic: (deviceId: string, stream?: MediaStream) => void;

    _setMics: (mics: MicInfo[]) => void;
    _disableMic: () => void;
    _stopStream: () => void;
    _grantAccess: () => void;
    _denyAccess: () => void;
};

export const useMicStore = create<MicState>((set, get) => ({
    accessDenied: undefined,
    mics: undefined,
    currentMicId: undefined,
    currentStream: undefined,
    selectMic: (deviceId: string, stream?: MediaStream) => {
        const { currentStream } = get();

        set({
            accessDenied: false,
            currentMicId: deviceId,
            currentStream: stream,
        });

        stopMediaStream(currentStream);
    },
    _setMics: (mics: MicInfo[]) => set({ mics }),
    _disableMic: () => {
        const { currentStream } = get();
        stopMediaStream(currentStream);

        set({
            currentMicId: undefined,
            currentStream: undefined,
        });
    },
    _stopStream: () => {
        const { currentStream } = get();
        stopMediaStream(currentStream);

        set({
            currentStream: undefined,
        });
    },
    _grantAccess: () =>
        set({
            accessDenied: false,
        }),
    _denyAccess: () =>
        set({
            accessDenied: true,
            mics: undefined,
            currentMicId: undefined,
            currentStream: undefined,
        }),
}));
